import React from 'react';
import PropTypes from 'prop-types';
import userManager from "../utils/userManager";
import withRoot from "../withRoot";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';


const styles = theme => ({
  root: {
    flexGrow: 1, 
    padding: 16,
    margin: 16
  },
});


class LoginPage extends React.Component {
  render() {
    const { classes } = this.props;
    
    return (
      <div className={classes.root}>
        <Grid container direction="column" justify="center" alignItems="center" spacing={16}>
          <Grid item>
            <Typography variant="display3">Welcome!</Typography>
          </Grid>
          <Grid>
            <Typography variant="subheading" gutterBottom>Please log in to continue</Typography>
          </Grid>
          <Grid>
            <Button 
            variant="contained" 
            color="primary" 
            onClick={ () => { userManager.signinRedirect(); } }>
            Login
          </Button>
         </Grid>  
        </Grid>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(LoginPage));


// WEBPACK FOOTER //
// ./src/containers/LoginPage.js